<template>
    <div class="scr-body">
        <!-- FUN FACTS WIDGET -->
        <h3>Interesting facts</h3>
        <carousel :perPage="1" :paginationPadding="0">
            <slide v-for="fact in guideContent.funFacts" :key="fact.id">
                <div class="fact">
                    <div class="fact-content">{{fact.fact}}</div>
                    <div class="fact-image">
                        <img :src="factImage(fact)" width="100" />
                    </div>
                </div>
            </slide>
        </carousel>

        <!-- TRANSPORT WIDGET -->
        <h3>Getting around</h3>
        <section>
            <div class="box-slider">
                <div class="slider-wrapper">
                    <div class="white-box slider-item">
                        <div class="white-box-content">
                            <h2>Taxi apps</h2>
                            <p>This is the easiest way to call a cab in Sofia. Apps are available in English and you can pay with cards.</p>
                            <p>
                                <a
                                    href="itms-apps://apps.apple.com/bg/app/yellow-taxi-91119/id1042670745"
                                    class="btn-text"
                                >
                                    <i class="icon-app-store accented-circle" target="_blank"></i>
                                </a>
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.autocab.taxibooker.yellow333.bulgaria&hl=en_US"
                                    target="_blank"
                                    class="btn-text"
                                >
                                    <i class="icon-play-store accented-circle"></i>
                                </a>
                                <b>&nbsp;Yellow taxi</b>
                            </p>
                            <p>
                                <a
                                    href="itms-apps://apps.apple.com/bg/app/taxime-client/id744137021"
                                    class="btn-text"
                                >
                                    <i class="icon-app-store accented-circle" target="_blank"></i>
                                </a>
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.taxime.client&hl=en_US"
                                    class="btn-text"
                                >
                                    <i class="icon-play-store accented-circle" target="_blank"></i>
                                </a>
                                <b>&nbsp;Taxi Me</b>
                            </p>
                        </div>
                    </div>
                    <div class="white-box slider-item">
                        <div class="white-box-content">
                            <h2>Electric rent-a-car</h2>
                            <p>Payment is by the minute and you can leave it (almost) wherever you want.</p>
                            <p>
                                <a
                                    href="https://itunes.apple.com/lt/app/spark-your-electric-drive/id1095645824?mt=8"
                                    class="btn-text"
                                >
                                    <i class="icon-app-store accented-circle" target="_blank"></i>
                                </a>
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.autocab.taxibooker.yellow333.bulgaria&hl=en_US"
                                    target="_blank"
                                    class="btn-text"
                                >
                                    <i class="icon-play-store accented-circle"></i>
                                </a>
                                <b>&nbsp;Spark</b>
                            </p>
                        </div>
                    </div>
                    <div class="white-box slider-item">
                        <div class="white-box-content">
                            <h2>Metro</h2>
                            <p>Direct line from Airport to City center. Connection to the Business park at station Mladost 1</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- NOTE: transport data is a bit different now -->

        <!-- <div class="sight" v-for="transport in guideContent.transports" :key="transport.name">
          <h2>{{transport.name}}</h2>
          <span>{{transport.description}}</span>
          <span>Language: {{transport.language}}</span>
          <span>Payment: {{transport.payment}}</span>
          <a :href="'tel:' + transport.phone" v-if="transport.phone">{{transport.phone}}</a>
          <a :href="transport.appStoreLink" target="_blank">AppStore Link</a>
          <a :href="transport.googlePlayStoreLink" target="_blank">Google Play Store Link</a>
        </div>-->

        <!-- HOTEL WIDGET -->
        <h3>Recommendations</h3>
        <section>
            <div class="box-slider">
                <div class="slider-wrapper">
                    <div
                        class="white-box slider-item"
                        v-for="hotel in guideContent.hotels"
                        :key="hotel.name"
                    >
                        <img :src="hotelImage(hotel)" width="100%" class="white-box-image" />
                        <div class="white-box-content">
                            <h2>
                                {{hotel.name}}
                                <span class="badge">
                                    {{hotel.stars}}
                                    <i class="icon-star"></i>
                                </span>
                            </h2>
                            <p>{{hotel.description}}</p>
                            <p>
                                <!-- TODO: add google maps link -->
                                <!-- {{hotel.address}} -->
                                <a class="btn-text" @click="navigateTo(hotel.address)">
                                    <i class="icon-pin accented-circle" target="_blank"></i>
                                </a>

                                <a :href="'tel:' + hotel.phone" class="btn-text">
                                    <i class="icon-phone accented-circle" target="_blank"></i>
                                </a>

                                <a :href="hotel.website" class="btn-text">
                                    <i class="icon-globe accented-circle" target="_blank"></i>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- RESTAURANT WIDGET -->
        <section>
            <div class="box-slider">
                <div class="slider-wrapper">
                    <div
                        class="white-box slider-item"
                        v-for="restaurant in guideContent.restaurants"
                        :key="restaurant.name"
                    >
                        <img :src="restaurantImage(restaurant)" width="100" class="white-box-image" />
                        <div class="white-box-content">
                            <h2>{{restaurant.name}}</h2>
                            <p>{{restaurant.description}}</p>
                            <p>
                                <!-- TODO: add google maps link -->
                                <!-- {{restaurant.address}} -->
                                <a class="btn-text" @click="navigateTo(restaurant.address)">
                                    <i class="icon-pin accented-circle" target="_blank"></i>
                                </a>

                                <a :href="'tel:' + restaurant.phone" class="btn-text">
                                    <i class="icon-phone accented-circle" target="_blank"></i>
                                </a>

                                <a :href="restaurant.website" class="btn-text">
                                    <i class="icon-globe accented-circle" target="_blank"></i>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- SIGHTSEEING WIDGET -->
        <section>
            <div class="box-slider">
                <div class="slider-wrapper">
                    <div
                        class="white-box slider-item"
                        v-for="sight in guideContent.sights"
                        :key="sight.name"
                    >
                        <img :src="sightImage(sight)" width="100" class="white-box-image" />
                        <div class="white-box-content">
                            <h2>{{sight.name}}</h2>
                            <p>{{sight.description}}</p>
                            <p>
                                <!-- TODO: add google maps link -->
                                <!-- {{sight.address}} -->
                                <a class="btn-text" @click="navigateTo(sight.address)">
                                    <i class="icon-pin accented-circle" target="_blank"></i>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- WEATHER WIDGET -->
        <h3>Weather</h3>
        <section>
            <div class="weather-item current-day">
                <div class="weather-date">Wed, 23</div>
                <div class="weather-temperature">
                    <img src="../assets/weather_icons/02d@2x.png" width="32" alt />27&deg;
                </div>
            </div>

            <div class="weather-item">
                <div class="weather-date">Thu, 23</div>
                <div class="weather-temperature">
                    <img src="../assets/weather_icons/04d@2x.png" width="32" />27&deg;
                </div>
            </div>

            <div class="weather-item">
                <div class="weather-date">Fri, 23</div>
                <div class="weather-temperature">
                    <img src="../assets/weather_icons/09d@2x.png" width="32" />27&deg;
                </div>
            </div>
        </section>
    </div>
</template>

<script>
//This component shows the tourist information about the visit.
import tour from "../store/tourGuide.json";
export default {
    name: "Guide",
    data() {
        return {
            guideContent: tour
        };
    },
    methods: {
        hotelImage(hotel) {
            return require("../assets/images/hotels/" + hotel.image);
        },
        factImage(fact) {
            return require("../assets/images/facts/" + fact.image);
        },
        restaurantImage(restaurant) {
            return require("../assets/images/restaurants/" + restaurant.image);
        },
        sightImage(sight) {
            return require("../assets/images/sights/" + sight.image);
        },
        navigateTo(address) {
            if (address.direct) {
                window.open(address.direct);
            } else {
                if (
                    /* if we're on iOS, open in Apple Maps */
                    navigator.platform.indexOf("iPhone") != -1 ||
                    navigator.platform.indexOf("iPad") != -1 ||
                    navigator.platform.indexOf("iPod") != -1
                )
                    window.open(
                        `maps://maps.google.com/maps?daddr=${address.latitude},${address.longitude}&amp;ll=`
                    );
                else
                    window.open(
                        `https://maps.google.com/maps?daddr=${address.latitude},${address.longitude}&amp;ll=`
                    );
            }
        }
    },
    created() {
        // Fired when the component is ready. <br/> Emitted for the Header to be changed to the correct title.
        // @arg The argument is a `String` value representing the current title.
        this.$emit("changed", "Local guide");
    }
};
</script>

<style>
.VueCarousel-pagination {
    width: calc(100% - 1.2rem) !important;
}
</style>
